import React from 'react';
import styled from '@emotion/styled';
import { cs } from '@bbkAdminUtils/css-utils';

export const InputLabel = styled.div`
  margin-top: 1rem;
  margin-bottom: 0.4rem;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.5);
`;

export const InputMessage = styled.div`
  line-height: 2rem;
  margin-left: 0.5rem;
  font-size: 14px;
`;

export const InputError: React.FC<React.ComponentProps<typeof InputMessage>> = (
  props
) => {
  const { className, ...restProps } = props;
  return (
    <InputMessage
      className={cs('tw-text-[#FB315DCC]', className)}
      {...restProps}
    />
  );
};

export const ImportantMessage: React.FC<
  React.ComponentProps<typeof InputMessage>
> = (props) => {
  const { className, ...restProps } = props;
  return (
    <InputMessage
      className={cs('!tw-m-0 tw-inline tw-text-[#FB315DCC]', className)}
      {...restProps}
    />
  );
};
